<template>
  <div class="back-center-panel">
    <div class="back-center" @click="handleJumpPage('OPEN_NEWSCENTER')">
      <div class="back-icon">
        <div class="back-link">返回新闻中心</div>
      </div>
    </div>
  </div>
</template>
<script>
import RouteKey from '@/common/RouteKey';
export default {
  name: 'BackOpenChenter',
  methods: {
    handleJumpPage(url, key) {
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, { key: key });
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>
<style lang="less">
  .back-center-panel {
    border-bottom: 1px solid #D2D7DF;
    .back-center {
      width: 1263px;
      margin: 0 auto 20px;  
      .back-icon{
        width: 200px;
        height: 20px;
        margin-top: 20px;
        margin-left: 30px;
        opacity: 0.8;
        background: url('../img/arrow_grey_l.svg') left center no-repeat;
        .back-link {
          height: 20px;
          padding-left: 30px;
          line-height: 20px;
          font-size: 14px;
          color: #3D485D;
        }
        &:hover {
          cursor: pointer;
          opacity: 1;
          background: url("../img/arrow_normal_l.svg") left center no-repeat;
          .back-link {
            color: #0080FF;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/BackOpenChenter.vue